'use strict';

/*
 *  Adds current url as a referrer attribute to user session links
 */
module.exports = Groupon.SharedJS.addReferrer = (function() {
  return {
    init: function() {
      var current_href, flags, ref1, referrer, selector;
      selector = '';
      flags = (ref1 = Groupon.PageFlags) != null ? ref1 : {};
      selector = flags.isTouch ? '#t-sign-in, #t-sign-out, .t-login-button' : '#ls-user-signin, #ls-user-signup, #ls-user-signin-with-flyout, #sign-out';
      current_href = location.href;
      current_href = current_href.replace(location.hash, '');
      current_href = current_href.replace(/[?&](ref|return_to)=([^&]*)?/, '');
      referrer = 'return_to=' + encodeURIComponent(current_href);
      return $(selector).each(function() {
        var ref, ref2;
        ref = /\?/.test(this.href) ? '&' : '?';
        ref += referrer;
        if (!((ref2 = Groupon.LS.flags) != null ? ref2.showSigninFlyout : void 0)) {
          ref += '&metric=layout_login';
        }
        return this.href += ref;
      });
    }
  };
})();

